import { useLayoutEffect } from 'react';

/**
 * Public marketing pages (landing, applications) are always shown in light theme
 * and in Dhivehi / RTL, like the login page. This hook forces that chrome while
 * the page is mounted and restores the user's real theme + the app's default
 * LTR/English direction on unmount, so the logged-in app is untouched.
 */
export function useMarketingChrome(): void {
  useLayoutEffect(() => {
    const html = document.documentElement;
    const prevDir = html.getAttribute('dir') ?? 'ltr';
    const prevLang = html.getAttribute('lang') ?? 'en';
    html.classList.remove('dark');
    html.setAttribute('dir', 'rtl');
    html.setAttribute('lang', 'dv');
    return () => {
      html.setAttribute('dir', prevDir);
      html.setAttribute('lang', prevLang);
      try {
        const stored = localStorage.getItem('wapoffice.theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (stored === 'dark' || (!stored && prefersDark)) html.classList.add('dark');
      } catch {
        /* ignore */
      }
    };
  }, []);
}
